<div>
  <mat-card class="cardWithShadow">
    <mat-card-content>
      <div class="header" style="margin-bottom: 35px;">
        <button *ngIf="type==2" color="warn" mat-flat-button (click)="rejectDisconunt()"
          [ngStyle]="{'background-color': 'red', 'color': 'white'}">
          <span *ngIf="!isSmallScreen">Rechazar Descuento</span>
          <fa-icon *ngIf="isSmallScreen" [icon]="icons.faXmark"></fa-icon>
        </button>
        <mat-card-title class="header-title">
          <p *ngIf="type==1" >Información</p>
          <p *ngIf="type==2" >Resolución de Descuento</p>
        </mat-card-title>
        <br>
        
        <button *ngIf="type==2" mat-flat-button (click)="aproveDiscount()"
          [ngStyle]="{'background-color': 'green', 'color': 'white'}">
          <span *ngIf="!isSmallScreen">Aprobar Descuento</span>
          <fa-icon *ngIf="isSmallScreen" [icon]="icons.faCheck"></fa-icon>
        </button>
      </div>
      <hr>
      <section class="section-indicator">
        <h3 class="indicator-title-label">Cotización {{quotation?.code}} <a style="color: #048801; cursor: pointer; margin-left: 10px;" 
          matTooltip="Enviar por whatsapp"
          (click)="OpenApproversModal()"
          >
          <i-tabler name="brand-whatsapp" class="icon-20 m-r-8"></i-tabler>
      </a></h3>
        <div class="main-indicator">
          <div class="indicator-group">
            <div class="indicator-section">
              <h4 class="indicator-name">Producto:</h4>
              <h4 class="detalle">{{item.productTypeName}}</h4>
            </div>
            <div class="indicator-section">
              <h4 class="indicator-name">Finalidad:</h4>
              <h4 class="detalle">{{item.targetName}}</h4>
            </div>
            <div class="indicator-section">
              <h4 class="indicator-name">Plazo:</h4>
              <h4 class="detalle">{{item.period}} Días</h4>
            </div>
          </div>

          <div class="indicator-group">
            <div class="indicator-section">
              <h4 class="indicator-name">Mandante:</h4>
              <h4 class="reduceText" matTooltip="{{item.beneficiaryName}}" matTooltipClass="custom-tooltip">
                {{item.beneficiaryName || 'No Informado'}}</h4>
            </div>
            <div class="indicator-section">
              <h4 class="indicator-name">Rut M.:</h4>
              <h4 class="detalle">{{item.rutBeneficiary || '-'}}</h4>
            </div>
            <div class="indicator-section">
              <h4 class="indicator-name">Monto:</h4>
              <h4 class="detalle">{{item.currencySymbol}}{{item.amount | number:'1.0-2'}}</h4>
            </div>
          </div>

          <div class="indicator-group">
            <div class="indicator-section">
              <h4 class="indicator-name">Precio:</h4>
              <h4 class="detalle">{{quotation.currency.symbol}}{{item.price | number:'1.0-2'}}</h4>
            </div>
            <div class="indicator-section">
              <h4 class="indicator-name">{{item.discount >= 0 ? 'Descuento' : 'Aumento'}}:</h4>
              <h4 class="detalle discount-section">
                {{quotation.currency.symbol}}{{(item.discount | abs) | number:'1.0-2'}}
                <app-dicount-icon [discount]="item.discountPercentage" receivedAs="rate"></app-dicount-icon>
              </h4>
            </div>
            <div class="indicator-section">
              <h4 class="indicator-name">Nuevo Precio:</h4>
              <h4 class="detalle">{{quotation.currency.symbol}}{{item.finalPrice | number:'1.0-2'}}</h4>
            </div>
          </div>

          <div class="indicator-group">
            <div class="indicator-section">
              <h4 class="indicator-name">Tasa S/CE:</h4>
              <h4 class="detalle">{{(item.rawRate * 100) | number:'1.0-2'}}%</h4>
            </div>
            <div class="indicator-section">
              <h4 class="indicator-name">Tasa C/CE:</h4>
              <h4 class="detalle">{{(item.rate * 100) | number:'1.0-2'}}%</h4>
            </div>
            <div class="indicator-section">
              <h4 class="indicator-name">IR:</h4>
              <h4 class="detalle">{{item.finalPrice/(item.amount*item.currencyExchange) * 100 | number:'1.0-2' }} %</h4>
            </div>
          </div>
        </div>
      </section>

      <div class="client-indicators-group section-indicator">
        <section>
          <h3 class="indicator-title-label">Cliente</h3>
          <div class="main-indicator">
            <div class="indicator-group">
              <div class="indicator-section">
                <h4 class="indicator-name">Nombre:</h4>
                <h4 class="detalle">{{quotation.customer.name}}</h4>
              </div>
              <div class="indicator-section">
                <h4 class="indicator-name">Rut:</h4>
                <h4 class="detalle">{{infoClient?.rut || legacySummaryInfo?.rutStr || quotation.customer.rut}}</h4>
              </div>
              <div class="indicator-section">
                <h4 class="indicator-name">Actividad:</h4>
                <h4 class="reduceText" matTooltip="{{infoClient?.currentActivity}}" matTooltipClass="custom-tooltip">
                  {{infoClient?.currentActivity}}</h4>
              </div>
            </div>
            <div *ngIf="!loadingState['legacySummaryInfo']; else loading">
              <ng-container>
                <div class="main-indicator">
                  <div class="indicator-group">
                    <div class="indicator-section">
                      <h4 class="indicator-name">Línea Aprobada:</h4>
                      <h4 class="detalle">{{(legacySummaryInfo?.linea || 0) | currency : "CLP" : "symbol"}}</h4>
                    </div>
                    <div class="indicator-section">
                      <h4 class="indicator-name">Línea usada:</h4>
                      <h4 class="detalle">{{(legacySummaryInfo?.totalUsedLine || 0) | currency: 'CLP' : 'symbol'}}</h4>
                    </div>
                    <div class="indicator-section">
                      <h4 class="indicator-name">Línea Disponible:</h4>
                      <h4 class="detalle">{{(legacySummaryInfo?.availableLine || 0) | currency: 'CLP' : 'symbol'}}</h4>
                    </div>  
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </section>
        <section>
          <h3 class="indicator-title-label">Scoring</h3>
          <div class="main-indicator">
            <div class="indicator-group">
              <div class="indicator-section">
                <h4 class="indicator-name">Estado Último Scoring:</h4>
                <h4 class="detalle">{{legacySummaryInfo?.lastScoringStateDescription || 'No solicitado'}}</h4>
              </div>
              <div class="indicator-section">
                <h4 class="indicator-name">Máxima Adjudicación:</h4>
                <h4 class="detalle">{{(legacySummaryInfo?.maxAdjudication || 0) | currency : "CLP" : "symbol"}}</h4>
              </div>
              <div class="indicator-section">
                <h4 class="indicator-name">Fecha Primera Adjudicación:</h4>
                <h4 class="detalle">
                  {{(returnCorrectDate(legacySummaryInfo?.firstAdjudication) | date : "dd/MM/yyyy") || 'Sin información'}}
                </h4>
              </div>
            </div>
  
            <div class="indicator-group">
              <div class="indicator-section">
                <h4 class="indicator-name">Dicom:</h4>
                <h4 class="detalle">
                  @if(dicom){
                    {{ dicom?.puntaje || '-' }}
                  }@else {
                    No consultado
                  }
                </h4>
              </div>
              <div class="indicator-section">
                <h4 class="indicator-name">Deuda:</h4>
                <h4 class="detalle">
                  @if(dicom) {
                    {{ dicom?.deudaDicom > 0 ? (dicom?.deudaDicom | currency: "CLP" : "symbol") : 'Sin deuda' }}
                  }@else {
                    No consultado
                  }
                </h4>
              </div>
              <div class="indicator-section">
                <h4 class="indicator-name">Fecha Consulta:</h4>
                <h4 class="detalle">{{ (dicom?.dateConsultaDicom | date: "dd/MM/yyyy") || 'No consultado' }}</h4>
              </div>
            </div>
          </div>
        </section>  
      </div>

      <section class="section-indicator">
        <h3 class="indicator-title-label">Historial {{item.targetName}} </h3>
        <ng-container *ngIf="!loadingState['legacySummaryInfo']; else loading">
          <div *ngIf="legacySummaryInfo; else noData">
            <section class="main-indicator" *ngIf="clientGuaranteeBehavior; else noData">
              <div class="indicator-group">
                <div class="indicator-section">
                  <h4 class="indicator-name">Monto Máximo:</h4>
                  <h4 class="detalle">{{ clientGuaranteeBehavior.guaranteeBehaviour.maxAmount | currency: 'CLP' : 'symbol' }}</h4>
                </div>
                <div class="indicator-section">
                  <h4 class="indicator-name">Tasa Máxima:</h4>
                  <h4 class="detalle">{{ (clientGuaranteeBehavior.guaranteeBehaviour.maxComissionRate * 100) | number: '1.0-2' }}%</h4>
                </div>
              </div>

              <div class="indicator-group">
                <div class="indicator-section">
                  <h4 class="indicator-name">Monto Promedio:</h4>
                  <h4 class="detalle">{{ clientGuaranteeBehavior.guaranteeBehaviour.averageAmount | currency: 'CLP' : 'symbol' }}</h4>
                </div>
                <div class="indicator-section">
                  <h4 class="indicator-name">Tasa Promedio:</h4>
                  <h4 class="detalle">{{ (clientGuaranteeBehavior.guaranteeBehaviour.averageComissionRate * 100) | number: '1.0-2' }}%</h4>
                </div>
              </div>

              <div class="indicator-group">
                <div class="indicator-section">
                  <h4 class="indicator-name">Último Monto:</h4>
                  <h4 class="detalle">{{ clientGuaranteeBehavior.guaranteeBehaviour.lastAmount | currency: 'CLP' : 'symbol' }}</h4>
                </div>
                <div class="indicator-section">
                  <h4 class="indicator-name">Última Tasa:</h4>
                  <h4 class="detalle">{{ (clientGuaranteeBehavior.guaranteeBehaviour.lastComissionRate * 100) | number: '1.0-2' }}%</h4>
                </div>
              </div>

              <div class="indicator-group">
                <div class="indicator-section">
                  <h4 class="indicator-name">Días Desde Última Operación:</h4>
                  <h4 class="detalle">{{ clientGuaranteeBehavior.guaranteeBehaviour.daysFromLastGuarantee }} Días</h4>
                </div>
                <div class="indicator-section">
                  <h4 class="indicator-name">Garantías:</h4>
                  <h4 class="detalle">{{ clientGuaranteeBehavior.guaranteeBehaviour.guaranteesCount }}</h4>
                </div>
              </div>
            </section>
          </div>
        </ng-container>
      </section>
      <div class="section-indicator">
        <div class *ngIf="type==2">
          <h3 style="text-decoration: underline; color: #003c8a;">Solicitud</h3>
          <div class="main-indicator" *ngIf="lastRequestedDiscount() as discountRequest; else noData">
            <div class="indicator-group">
              <div class="indicator-section section-wrap">
                <h4 class="indicator-name">Detalle:</h4>
                <h4 class="detalle">{{discountRequest.changeRequestLogs[0].logMessage}}</h4>
              </div>
              <div class="indicator-section section-wrap">
                <h4 class="indicator-name">Motivo:</h4>
                <h4 class="detalle">{{discountRequest.reason}}</h4>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="type==1">
          <h3 style="text-decoration: underline; color: #003c8a;">Registros</h3>
          <div class="logging-historic-section">
            @for(log of getSaleQuoteHistoricLogs(); track log.id){
              <mat-card class="card-log">
                <section class="log-card-content">
                  <div class="log-date-section log-content-section">
                    <span>{{log.logDate | date : 'dd-MM-yyyy'}}</span>
                    <span>{{log.logDate | date: 'H:mm'}}</span>
                  </div>
                  <div class="log-content-section">
                    <span>
                      {{log.logMessage}}
                    </span>    
                  </div>
                </section>
              </mat-card>
            }@empty {
              <ng-container *ngTemplateOutlet="noData"></ng-container>
            }
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>


<ng-template #loading>
  <td colspan="3">
    <h4>Cargando...</h4>
  </td>
</ng-template>
<ng-template #noData>
  <td colspan="3">
    <h4 class="detalle" style="color: red;">Sin Información</h4>
  </td>
</ng-template>